import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import { store } from '@/store';
import { AuthServiceCreator } from '@/services/authService';

import Home from '../areas/kunde/home/views/S200_Home.vue';
import Login from '../areas/kunde/home/views/Login.vue';
import Lieferantenrechnungen from '../areas/kunde/lieferantenrechnung/views/S250_Lieferantenrechnungen.vue';
import PraxisgruppeRechnungen from '../areas/praxisgruppe/views/S700_PraxisgruppeRechnungen.vue';
import PraxisgruppeTeilnehmerAdministration from '../areas/praxisgruppeadministration/views/S710_PraxisgruppeTeilnehmerAdministration.vue';
import PraxisgruppeEinstellungen from '../areas/praxisgruppeadministration/views/S720_PraxisgruppeEinstellungen.vue';
import TreuhandTeilnehmerListe from '../areas/treuhand/views/S610_TreuhandTeilnehmerListe.vue';
import LieferantRechnungen from '../areas/lieferant/views/S500_LieferantRechnungen.vue';
import LieferantFehlerhafteRechnungen from '../areas/lieferant/views/S530_LieferantFehlerhafteRechnungen.vue';
import S540LieferantRechnungFormular from '../areas/lieferant/views/S540_LieferantRechnungFormular.vue';
import LieferantDokumentArchiv from '../areas/lieferant/views/S520_LieferantDokumentArchiv.vue';
import S530LieferantEinstellungen from '../areas/lieferantadministration/views/S530_LieferantEinstellungen.vue';
import TvsKundenListe from '../areas/lieferant/views/S510_TvsKundenListe.vue';
import TreuhandEinstellungen from '../areas/treuhandadministration/views/S620_TreuhandEinstellungen.vue';
import ProfilEinstellungen from '../areas/kunde/profileinstellungen/views/ProfilEinstellungen.vue';
import Registration from '../areas/kunde/registrierung/views/RegistrationForm.vue';
import Dokumentarchiv from '../areas/kunde/archiv/views/Dokumentarchiv.vue';
import Dokumentupload from '../areas/kunde/upload/views/Dokumentupload.vue';
import Konfiguration from '../areas/administration/views/S960_Konfiguration.vue';
import TeilnehmerAdmin from '../areas/administration/views/S900_TeilnehmerAdministration.vue';
import TakeTeilnehmer from '../areas/administration/views/S900_TakeTeilnehmer.vue';
import VetpointDaten from '../areas/administration/views/S920_VetpointDaten.vue';
import BenutzerSuche from '../areas/administration/views/S915_BenutzerSuche.vue';
import FehlerhafteRechnungen from '../areas/administration/views/S950_FehlerhafteRechnungen.vue';
import LieferantenDokumentUpload from '@/areas/administration/views/S930_LieferantenDokumentUpload.vue';
import AdminLieferantDokumentArchiv from '@/areas/administration/views/S940_AdminLieferantDokumentArchiv.vue';
import { LOGGEDIN } from '@/store/modules/security/mutations';
import { NAME as SecurityModule } from '@/store/modules/security';
import { GET_PERMISSIONS } from '@/store/modules/security/actions';

const routes: Array<RouteRecordRaw> = [
    { path: '/', redirect: '/home' },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        props: (route) => ({ ...route.query, ...route.params })
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lieferantenrechnungen',
        name: 'Lieferantenrechnungen',
        component: Lieferantenrechnungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lieferantrechnungformular',
        name: 'LieferantRechnungFormular',
        component: S540LieferantRechnungFormular,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/praxisgrupperechnungen',
        name: 'PraxisgruppeRechnungen',
        component: PraxisgruppeRechnungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/praxisgruppeteilnehmeradministration',
        name: 'PraxisgruppeTeilnehmerAdministration',
        component: PraxisgruppeTeilnehmerAdministration,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/praxisgruppeeinstellungen',
        name: 'PraxisgruppeEinstellungen',
        component: PraxisgruppeEinstellungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/einstellungen',
        name: 'Einstellungen',
        component: ProfilEinstellungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/registration',
        name: 'Registration',
        component: Registration
    },
    {
        path: '/dokumentarchiv',
        name: 'Dokumentarchiv',
        component: Dokumentarchiv,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/dokumentupload',
        name: 'Dokumentupload',
        component: Dokumentupload,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/konfiguration',
        name: 'Konfiguration',
        component: Konfiguration,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/taketeilnehmer',
        name: 'TakeTeilnehmer',
        component: TakeTeilnehmer,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lieferantendokumentupload',
        name: 'LieferantenDokumentUpload',
        component: LieferantenDokumentUpload,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/adminlieferantdokumentarchiv',
        name: 'AdminLieferantDokumentArchiv',
        component: AdminLieferantDokumentArchiv,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/teilnehmeradministration',
        name: 'TeilnehmerAdmin',
        component: TeilnehmerAdmin,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/benutzersuche',
        name: 'BenutzerSuche',
        component: BenutzerSuche,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/vetpointdaten',
        name: 'VetpointDaten',
        component: VetpointDaten,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/fehlerhafterechnungen',
        name: 'FehlerhafteRechnungen',
        component: FehlerhafteRechnungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/treuhandteilnehmer',
        name: 'TreuhandTeilnehmerListe',
        component: TreuhandTeilnehmerListe,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/treuhandeinstellungen',
        name: 'TreuhandEinstellungen',
        component: TreuhandEinstellungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lieferantrechnungen',
        name: 'LieferantRechnungen',
        component: LieferantRechnungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lieferantfehlerhafterechnungen',
        name: 'LieferantFehlerhafteRechnungen',
        component: LieferantFehlerhafteRechnungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/tvskundenliste',
        name: 'TvsKundenListe',
        component: TvsKundenListe,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lieferantdokumentarchiv',
        name: 'LieferantDokumentArchiv',
        component: LieferantDokumentArchiv,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/lieferanteinstellungen',
        name: 'LieferantEinstellungen',
        component: S530LieferantEinstellungen,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        const authService = await AuthServiceCreator.getAuthService();

        if (!(await authService.isLoggedIn())) {
            console.log('not logged in');
            store.commit(SecurityModule + '/' + LOGGEDIN, false);
            return { path: '/login', query: { nextUrl: to.fullPath } };
        }

        // Ensure permissions are fully loaded before proceeding
        if (!store.getters['security/permissionsLoaded']) {
            console.log('Waiting for permissions to load...');
            await store.dispatch('security/' + GET_PERMISSIONS);
        }
    }
});

export default router;
